var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row gap-2 mt-4"},_vm._l((_vm.highlightedLenders),function(lender){return _c('lender',{key:lender.id,attrs:{"lender":lender,"alternate-data-config":_vm.alternateDataConfig}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }